import { render, staticRenderFns } from "./CreateHoliday.vue?vue&type=template&id=18c3c9dc&"
import script from "./CreateHoliday.vue?vue&type=script&lang=js&"
export * from "./CreateHoliday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports